var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-content"},[_c('OrderHeader'),(_vm.userPaymentFailed)?_c('PaymentFailedBanner'):_vm._e(),_c('main',{staticClass:"order-page"},[_c('div',{staticClass:"order-page__content"},[(_vm.loading)?_c('app-loader'):_vm._e(),(!_vm.loading)?_c('router-view'):_vm._e()],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }